import { useState, useEffect } from 'react';
import { t } from 'i18next'
import { useLazyQuery } from '@apollo/client';
import { GET_ROUTE_STATUS } from 'graphql/route/queries';

export function RouteStatusDropdown({ fields, error, helperText, purpose }) {
  const [boatRouteList, setBoatRouteStatusList] = useState(null)
  const [getRouteStatusList, { loading: statusListLoading, error: statusListError }] = useLazyQuery(GET_ROUTE_STATUS, {

    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      if (data.boatRouteStatus.length > 0) {
        setBoatRouteStatusList(data.boatRouteStatus)
      }
    },
  })

  // get Type List
  const getBoatStatus = () => {
    getRouteStatusList({
      variables: {
        "code": null
      },
    })
  }
  useEffect(() => {
    getBoatStatus();
  }, []);

  return (
    <>
      {/* {statusListLoading && <div className="flex justify-center items-center bg-white py-5">Loading ....</div>} */}
      {statusListError && (
        <select>
          <option value={null}>{t('No data found')}</option>
        </select>
      )}
      {!statusListLoading && !statusListError && boatRouteList?.length === 0 && (
        <select>
          <option value={null}>{t('No data found')}</option>
        </select>
      )}
      {!statusListLoading && !statusListError && boatRouteList?.length > 0 && (
        <select
          {...fields}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:max-w-xs sm:text-sm sm:leading-6"
        >
          {purpose === 'filter' ? <option value={null}> {t('All')} </option> : <option value="" disabled> {t('Select Status')} </option>}
          {boatRouteList.map((boatRoute) => (
            <option key={boatRoute.code} value={boatRoute.code}>
              {boatRoute.description.en}
            </option>
          ))}
        </select>
      )}
      {error && <p className="text-error text-xs mt-1">
        {helperText}
      </p>}
    </>
  );
}

